module.exports = __webpack_public_path__ + "static/media/left-shop-arrow.d9a7f8f9.png";